<div *ngIf="message" class="notification {{type ? type : ''}}">
{{message | translate}}
</div>
<div *ngIf="html" [innerHTML]="html" class="notification {{type ? type : ''}}"></div>
